// URL Auth
export const Login_Url = '/oauth/token';
export const Logout_Url = '/oauth/logout';
export const Forget_Url = '/password/email';
export const Reset_Url = '/password/reset'; // pass tokrn parameter

// URL User
export const Get_User_Url = '/oauth/users';

// URL Config
export const Config_Url = '/config';

// URL Modules
export const Module_Url = '/modules'; // need to pass /:moduleId
export const User_Module_Url = '/user/modules';
export const Modules_Groups_Url = '/group_modules';

// Sub module
export const Watch_Sub_Module_Url = '/sub_modules';
export const Complete_Sub_Module_Url = '/sub_modules';

// Sub Module Quiz
export const Sub_Module_Quiz = '/quiz'; // need to pass /:subModuleId
export const Sub_Module_Quiz_answer = '/quiz/submit';

// certificate
export const Module_Group_Certificate = '/group_modules/1/certificate';

// featured resources

export const FeaturedResources = '/resource/featured';

// group resources

export const GroupResources = '/resource/groups';

export const GroupResourcesById = '/resource/group';

export const GroupResourcesSearch = '/resource/search';

// hot topic routes

export const Hottopic = '/hottopic';

// sign up emails

export const Signup_Url = '/oauth/register';

// get all certificates

export const Get_All_Certificates = '/certificate';
